import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { canPrepareReserve } from 'helpers/accounts'
import {
    getEndDateMessage,
    getFormattedTime,
} from 'helpers/datetime'

import { Button, Tooltip } from 'react-wot-bootstrap'

import LackOfIndustrialResource from 'components/LackOfIndustrialResource/LackOfIndustrialResource.jsx'
import ProductionProgress from 'components/ProductionProgress/ProductionProgress.jsx'
import Warning from 'components/Warning/Warning.jsx'
import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'

import ReservesSlider from '../ReservesSlider/ReservesSlider.jsx'

import submitReserveProduce, { changeSelectedCount } from 'state/actions/reserve_produce'
import { openCancelConfirmation } from 'state/actions/reserve_produce_cancel'
import { playCancelClickSound, playHoverSound } from 'state/actions/sounds'

import {
    RESERVE_PRODUCE_TITLE,
    RESERVE_PRODUCE_COST,
    RESERVE_PRODUCE_DURATION,
    RESERVE_PRODUCE_SUBMIT,
    RESERVE_PRODUCE_WARNING,
    TOTAL_DURATION_TOOLTIP_ID,
    INDUSTRIAL_RESOURCE_TOOLTIP_ID,
    TOTAL_DURATION_TOOLTIP_CONTENT,
} from './constants.jsx'

import styles from './ReserveProduce.scss'

export class ReserveProduce extends React.Component {
    static propTypes = {
        buildingId: PropTypes.number.isRequired,
        cost: PropTypes.number.isRequired,
        duration: PropTypes.number.isRequired,
        reserveQueue: PropTypes.arrayOf(PropTypes.object),
        industrialResourceAvailable: PropTypes.number.isRequired,
        selectedCount: PropTypes.number.isRequired,
        hasPermission: PropTypes.bool.isRequired,
        fade: PropTypes.bool,
        selectedLevel: PropTypes.number.isRequired,
        changeSelectedCount: PropTypes.func.isRequired,
        playCancelClickSound: PropTypes.func.isRequired,
        playHoverSound: PropTypes.func.isRequired,
        submitReserveProduce: PropTypes.func.isRequired,
        handleCancel: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)
        this.handleCancelClick = this.handleCancelClick.bind(this)
    }

    componentWillUnmount() {
        this.props.changeSelectedCount(1, false)
    }
    getTotalDurationTooltipContent(seconds) {
        return TOTAL_DURATION_TOOLTIP_CONTENT(
            <span className={styles.finish}>
                {getEndDateMessage(moment().add(moment.duration({ seconds })))}
            </span>
        )
    }
    handleCancelClick() {
        this.props.playCancelClickSound()
        this.props.handleCancel()
    }
    render() {

        const totalDuration = this.props.duration * this.props.selectedCount
        let productionEndsFor = totalDuration
        if (this.props.reserveQueue.length > 0) {
            const lastReserveInQueue = this.props.reserveQueue[this.props.reserveQueue.length - 1]

            if (lastReserveInQueue.productionEnds > Date.now()) {
                productionEndsFor += Math.round((lastReserveInQueue.productionEnds - Date.now()) / 1000)
            }
        }

        let totalDurationTooltip

        const availableCount = Math.floor(this.props.industrialResourceAvailable / this.props.cost)
        const notEnough = this.props.selectedCount > availableCount
        const totalCost = this.props.cost * this.props.selectedCount
        const buildingId = this.props.buildingId

        let industrialResourceTooltip
        let footerComponent
        let sliderComponent
        let expandedCostColumn
        let expandedDurationColumn

        if (this.props.hasPermission) {

            if (notEnough) {
                const notEnoughResourceComponent = (
                    <IndustrialResource
                        value={Math.abs(this.props.industrialResourceAvailable - totalCost)}
                        small
                    />
                )
                industrialResourceTooltip = (
                    <Tooltip id={INDUSTRIAL_RESOURCE_TOOLTIP_ID}>
                        <LackOfIndustrialResource resource={notEnoughResourceComponent} />
                    </Tooltip>
                )
            }

            sliderComponent = (
                <ReservesSlider
                    value={this.props.selectedCount}
                    handleChange={this.props.changeSelectedCount}
                    handleHover={this.props.playHoverSound}
                    maxAvailableValue={Math.floor(this.props.industrialResourceAvailable / this.props.cost)}
                />
            )
            expandedCostColumn = (
                <td className={styles.td}>
                    {`${this.props.selectedCount} \u00d7 `}
                    <IndustrialResource value={this.props.cost} small />
                </td>
            )
            expandedDurationColumn = (
                <td className={styles.td}>
                    {`${this.props.selectedCount} \u00d7 `}
                    <span className={`${styles.duration} ${styles.duration__small}`}>
                        {getFormattedTime(this.props.duration * 1000)}
                    </span>
                </td>
            )
            footerComponent = (
                <div className={styles.footer}>
                    <Button
                        onClick={this.props.submitReserveProduce.bind(
                            null,
                            buildingId,
                            this.props.selectedCount,
                            this.props.selectedLevel
                        )}
                        isDisabled={notEnough}
                        tooltipId={INDUSTRIAL_RESOURCE_TOOLTIP_ID}
                    >
                        {RESERVE_PRODUCE_SUBMIT}
                    </Button>
                </div>
            )

            totalDurationTooltip = (
                <Tooltip
                    id={`${TOTAL_DURATION_TOOLTIP_ID}${this.props.buildingId}`}
                    getContent={this.getTotalDurationTooltipContent.bind(null, productionEndsFor)}
                />
            )
        } else {
            footerComponent = (
               <div className={styles.warning}>
                   <Warning>{RESERVE_PRODUCE_WARNING}</Warning>
               </div>
           )
        }
        const baseClassName = classNames(styles.base, {
            [styles.base__fade]: this.props.fade,
        })

        return (
            <div className={baseClassName}>
                <h3 className={styles.title}>{RESERVE_PRODUCE_TITLE}</h3>
                <ProductionProgress
                    key={this.props.selectedLevel}
                    hasPermission={this.props.hasPermission}
                    reserveQueue={this.props.reserveQueue}
                    onCancel={this.handleCancelClick}
                    playHoverSound={this.props.playHoverSound}
                />
                <div className={styles.holder}>
                    {sliderComponent}
                    <table className={styles.table}>
                        <tbody>
                            <tr className={styles.tr}>
                                <th className={styles.th}>{RESERVE_PRODUCE_COST}</th>
                                {expandedCostColumn}
                                <td className={styles.td}>
                                    <IndustrialResource
                                        value={totalCost}
                                        notEnough={this.props.hasPermission ? notEnough : false}
                                        popoverId={INDUSTRIAL_RESOURCE_TOOLTIP_ID}
                                    />
                                </td>
                            </tr>
                            <tr className={styles.tr}>
                                <th className={styles.th}>{RESERVE_PRODUCE_DURATION}</th>
                                {expandedDurationColumn}
                                <td className={styles.td}>
                                    <span
                                        className={styles.duration}
                                        data-tip data-for={`${TOTAL_DURATION_TOOLTIP_ID}${this.props.buildingId}`}
                                    >
                                        {getFormattedTime(totalDuration * 1000)}
                                    </span>
                                    {totalDurationTooltip}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {footerComponent}
                {industrialResourceTooltip}
            </div>
        )
    }
}

export const mapStateToProps = (state, { buildingId, reserve }) => {
    const building = state.buildings[buildingId]
    const selectedLevel = state.reserveLevelSelect.selectedLevel

    return {
        cost: reserve.conditions[selectedLevel - 1].production_cost,
        duration: reserve.conditions[selectedLevel - 1].production_time,
        reserveQueue: state.clanReserves[reserve.type].filter(({ level }) => level === selectedLevel),
        industrialResourceAvailable: state.clan.industrial_resource,
        selectedCount: state.reserveProduce.selectedCount,
        hasPermission: canPrepareReserve(state.account),
        fade: state.buildingUpgrade.highlighted,
        buildingId: building.id,
        selectedLevel,
    }
}

export const mapDispatchToProps = {
    changeSelectedCount,
    handleCancel: openCancelConfirmation,
    playCancelClickSound,
    playHoverSound,
    submitReserveProduce,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReserveProduce)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/ReserveProduce/ReserveProduce.jsx